import React from 'react';
import { BarChart, XAxis, YAxis, CartesianGrid, Tooltip, Bar, ResponsiveContainer } from 'recharts';
import { useSelector } from "react-redux";


const SimpleBarChartInternal = (props) => {
    const { DateFilters } = props;
    // Data for the bar chart

    const state = useSelector((state) => state);
    const graphData =
    state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata?.PercentageGraphData || []
    //   state.Ticketingrecord_dashboard?.ticketDashboardData?.GraphData || [];

    const countofpercentage =
    state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata?.GraphData || []

        const mergedData = graphData.map((data, index) => ({
            x: index,  // Use the index as the x value
            y: countofpercentage[index] || 0,   // Map PercentageGraphData to y
            percentage: data   // Add the corresponding value from GraphData to the response
        }));
        
        const finalMergedData = mergedData.map((item, index) => ({
            ...item,
            additionalData: graphData[index]?.someProperty || null,  // Example of adding more data from PercentageGraphData if necessary
        }));


    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const Week = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

    const labeldata = countofpercentage.map((value, index) => {
        const key =
            DateFilters === 'ThisWeek'
                ? `Day ${index + 1}`
                : DateFilters === 'ThisMonth'
                    ? `Week ${index + 1}`
                    : monthNames[index % 12];

        return {
            x: key,  
            y: value,
        };
    });


    const labeldatarespo = labeldata.map((item) => ({
        x: item.x,  // Copy x value (same as in data)
        y: item.y,  // Copy y value (same as in data)
    }));



    const data = graphData.map((value, index) => {
        const key =
            DateFilters === 'ThisWeek'
                // ? ` ${index + 1}`
                ? Week[index % 7]
                : DateFilters === 'ThisMonth'
                    ? `Week ${index + 1}`
                    : monthNames[index % 12];

        return {
            x: key,  // Use index for the x value (matching the format you requested)
            y: value,  // Map the data value to the y value
        };
    });




    return (


        <>
            <div className='card OpeningChartDetails'>
                <div className='card-body'>
                    <p><span>X axis - </span> <span>{state.StateManagementOverallCall.DefualtDatefilyer == "ThisWeek" ?
                        "Day" : state.StateManagementOverallCall.DefualtDatefilyer == "ThisMonth" ?
                            "Week" : "Month"}
                    </span></p>
                    <p><span>Y axis - </span> <span>Percentage</span></p>

                </div>
            </div>



            <ResponsiveContainer width="100%" height={358}>
                <BarChart data={data}>

                    <XAxis dataKey="x" type="category" domain={['dataMin', 'dataMax']} />

                    <YAxis type="number" domain={[0, 100]}/>


                    <Bar dataKey="y" fill="#234492"
                        radius={[10, 10, 0, 0]} // Top-left and top-right corners have rounded borders

                     
                        label={({ x, y, width, height, index }) => {
                            const labelValue = finalMergedData[index].y;  // Get y value from label data using index
                            const percentageValue = finalMergedData[index].percentage;  // Get percentage value
                    
                            const adjustedY = y + height / 2;  // Adjust label vertically to be centered on the bar
                            
                            return (
                              <text
                                x={x + width / 2}  // Horizontally center the label within the bar
                                y={adjustedY}
                                fill="#fff"
                                fontSize={19}
                                textAnchor="middle"
                                dominantBaseline="middle"
                                className="Textbarslisted"
                                pointerEvents="none"  // Disable pointer events on the label
                              >
                                {labelValue === 0 ? "" : labelValue }  
                              </text>
                            );
                          }}
                    




                    />
                </BarChart>
            </ResponsiveContainer>

        </>


    );
};

export default SimpleBarChartInternal;

